export var MuiFormLabel = {
  styleOverrides: {
    root: {
      fontWeight: 500
    }
  }
};
//# sourceMappingURL=MuiFormLabel.js.map